const WA_LINK = "https://wa.me/554891802091?text=Ol%C3%A1,%20gostaria%20de%20informa%C3%A7%C3%B5es%20das%20m%C3%A1quinas.........";

export default function Footer() {
  const handleWhatsAppClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (typeof window !== 'undefined' && (window as any).gtag_report_conversion) {
      (window as any).gtag_report_conversion(WA_LINK, true);
    } else {
      window.open(WA_LINK, '_blank');
    }
  };

  return (
    <footer className="bg-gray-950 text-white" id="contato">
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
          <div className="md:col-span-2">
            <img
              alt="SoldaGeo logo"
              className="h-[46px] w-auto object-contain object-left mb-4 brightness-0 invert"
              src="https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=375,h=101,fit=crop/A0xVvobDbRIBrVE7/rapidgeo__2_-removebg-preview-reducido-d95gQJQOpJIwwOxp.png"
            />
            <p className="text-gray-400 text-sm leading-relaxed max-w-xs">
              Importadora e distribuidora de máquinas de solda para geomembrana. Mais de 10 anos de experiência
              no Brasil e na Argentina.
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a
                href="https://www.facebook.com/share/17JUHvyQmW/"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-gray-800 text-gray-400 hover:border-green-500 hover:text-green-400 transition-all cursor-pointer"
              >
                <i className="ri-facebook-fill" />
              </a>
              <a
                href="https://www.instagram.com/soldageobrasil/"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-gray-800 text-gray-400 hover:border-green-500 hover:text-green-400 transition-all cursor-pointer"
              >
                <i className="ri-instagram-line" />
              </a>
              <a
                href={WA_LINK}
                target="_blank"
                rel="noopener noreferrer nofollow"
                onClick={handleWhatsAppClick}
                className="w-9 h-9 flex items-center justify-center rounded-full border border-gray-800 text-gray-400 hover:border-green-500 hover:text-green-400 transition-all cursor-pointer"
              >
                <i className="ri-whatsapp-line" />
              </a>
            </div>
          </div>

          <div>
            <h6 className="text-xs font-black uppercase tracking-widest text-green-400 mb-4">Endereço</h6>
            <div className="flex items-start gap-2 text-gray-400 text-sm">
              <i className="ri-map-pin-line mt-0.5 flex-shrink-0 text-green-500" />
              <span className="leading-relaxed">
                Rua Hipólito Gregório Pereira 127<br />
                Canasvieiras<br />
                Florianópolis — SC
              </span>
            </div>
          </div>

          <div>
            <h6 className="text-xs font-black uppercase tracking-widest text-green-400 mb-4">Contato</h6>
            <div className="flex flex-col gap-3">
              <a
                href={WA_LINK}
                target="_blank"
                rel="noopener noreferrer nofollow"
                onClick={handleWhatsAppClick}
                className="flex items-center gap-2 text-gray-400 hover:text-green-400 text-sm transition-colors cursor-pointer"
              >
                <i className="ri-whatsapp-line text-green-500" />
                +55 48 991802091
              </a>
              <a
                href="mailto:contato@soldageo.com.br"
                className="flex items-center gap-2 text-gray-400 hover:text-green-400 text-sm transition-colors cursor-pointer"
              >
                <i className="ri-mail-line text-green-500" />
                contato@soldageo.com.br
              </a>
            </div>
            <div className="mt-5 p-3 bg-gray-900 rounded-xl border border-gray-800">
              <p className="text-gray-500 text-xs mb-0.5">CNPJ</p>
              <p className="text-gray-300 text-sm font-mono">62.017.768/0001-25</p>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-2 text-center sm:text-left">
          <p className="text-gray-600 text-xs">© 2026 SoldaGeo Importações. Todos os direitos reservados.</p>
          <p className="text-gray-700 text-xs">Máquinas de solda geomembrana — Brasil &amp; Argentina</p>
        </div>
      </div>
    </footer>
  );
}
